import $ from 'jquery';
import formatMoney from './format-money';

export default function updateMenuCart(cart) {
  const $cartCount = $('#cart-count');
  $cartCount.text(formatMoney(cart.total));
}
